import { createContext } from '@wordpress/element';

const DataContext = createContext();

export const DataConsumer = DataContext.Consumer;
export const DataProvider = DataContext.Provider;
